import { createContext, useContext } from 'react';

const Project = createContext({
  id: null,
  name: null,
  published: false,
  slug: null,
  categories: [],
  tags: [],
  organization_id: null,
});

export const useProject = () => useContext(Project);

export default Project;
